export enum WebToAppModalType {
  BASIC = 'home',
  EFFECT = 'effect',
  MESSAGE = 'message',
  LIVENESS_FAILED = 'liveness_failed',
  LIVENESS_PENDING = 'liveness_pending',
  LIVENESS_YOTI_OVERCONSTRAINED = 'liveness_yoti_overconstrained',
  LIVENESS_YOTI_UNSUPPORTED_BROWSER = 'liveness_yoti_unsupported_browser',
}

export interface WebToAppModalProps {
  type: WebToAppModalType;
  onClose?: () => void;
  trigger?: string;
}
